import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);

Vue.axios.defaults.baseURL = '/';
Vue.axios.defaults.headers.common['X-Chat-Version'] = process.env.VUE_APP_NAME + '@' + process.env.VUE_APP_VERSION;
Vue.axios.defaults.withCredentials = true;

Vue.use(VueI18n);

const messages = {
    sv: {},
    nb: {},
};

const i18n = new VueI18n({
    locale: 'sv',
    messages,
});

new Vue({
    router,
    i18n,
    render: h => h(App),
}).$mount('#app');
